var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"yt-group-list"},[(_vm.stateFilterBySchool)?_c('GridTable',{key:_vm.componentKey,ref:"gridTable",attrs:{"id":"GradeList","title":("" + _vm.title + (_vm.appendTitle || '')),"urlPath":"gradesCms","columns":_vm.columns,"schema":_vm.schema,"defaultServerParams":{
      _fields: '_id,name,code,school._id,school.name,isActive',
      schoolId: _vm.filteredBySchool
    }},on:{"setModeSchema":_vm.onSetModeSchema}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b72b7090","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/subjects/GradeList.vue
// module id = null
// module chunks = 